import {RouteService} from "../../../../../services/routeService";
import {NotificationService} from "../../../../../services/notificationService";
import {DICTIONARY} from "../../../../../dictionary";
import {Component, OnInit} from "@angular/core";
import _ from "lodash";
import * as util from 'util';


@Component({
	selector: 'security-awareness-component',
	templateUrl: './security-awareness.component.html',
})
export class SecurityAwarenessComponent implements OnInit {
	constructor(private rs:RouteService,
				private ns:NotificationService) {
	}
	dic = DICTIONARY;
	planInfo;
	smartBannerStatus;
	mailboxes = [];
	getSecurityAwarenessDataInProcess;
	updatePolicyInProcess;
	_ = _;
	excludedMailboxes;

	ngOnInit() {
		this.getSecurityAwarenessDataInProcess = true;
		Promise.all([this.getSecurityAwarenessInfo(), this.getMailboxesForSecurityAwareness()])
			.then(results => {
				this.getSecurityAwarenessDataInProcess = false;
			})
			.catch(error => {
				this.getSecurityAwarenessDataInProcess = false;
			});
	};

	getSecurityAwarenessInfo = () => {
		return new Promise(resolve => {
			this.rs.getSecurityAwarenessInfo().then(response => {
				this.planInfo = response;
				this.smartBannerStatus = this.planInfo?.security_awareness?.smart_banner?.enable_status || null;
				this.syncPreviewSeverityTab();
				resolve({});
			}, (err) => {});
			resolve({});
		});
	}

	getMailboxesForSecurityAwareness = () => {
		return new Promise(resolve => {
			this.rs.getMailboxesForSecurityAwareness().then(response => {
				response = response || [];

				this.mailboxes = [];
				response.forEach(mailbox => {
					this.mailboxes.push({
						email: mailbox.email,
						selected: mailbox.security_awareness?.enabled || false,
						skip: mailbox.security_awareness?.skip || false,
					});
				});
				this.excludedMailboxes = this.mailboxes.map(mailbox => ({...mailbox, selected: mailbox.skip === true}));
				resolve({});
			}, (err) => {
				resolve({});
			});
		});
	}

	updateSecurityAwarenessEnable = () => {
		if (this.updatePolicyInProcess) {
			return;
		}

		const actionInfo: any = {
			action: this.dic.CONSTANTS.securityAwarenessActions.status,
			enable_status: this.smartBannerStatus
		};

		switch (this.smartBannerStatus) {
			case this.dic.CONSTANTS.groupSelection.all:
				const excludedMailboxes = _.filter(this.excludedMailboxes, 'selected');

				if (excludedMailboxes.length) {
					if (_.every(this.excludedMailboxes, 'selected')) {
						this.ns.showWarnMessage('Cannot exclude all mailboxes when \'All mailboxes\' is selected');
						return;
					}
					actionInfo.mailboxes = _.map(excludedMailboxes, 'email');
				}
				break;

			case this.dic.CONSTANTS.groupSelection.specific:
				const selectedMailboxes = _.filter(this.mailboxes, 'selected');

				if (!selectedMailboxes.length) {
					this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.selectAtLeastOneX, 'mailbox'));
					return;
				}

				actionInfo.mailboxes = _.map(selectedMailboxes, 'email');
				break;
		}

		this.updatePolicyInProcess = true;

		this.rs.updateSecurityAwarenessInfo(actionInfo).then(response => {
			this.planInfo.security_awareness.smart_banner.enable_status = this.smartBannerStatus;
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			this.updatePolicyInProcess = false;

		}, err => {
			this.updatePolicyInProcess = false;
		});
	};

	updateSecurityAwarenessAllowReport = () => {

		const actionInfo = {
			action: this.dic.CONSTANTS.securityAwarenessActions.allowReport,
			enabled: this.planInfo.security_awareness.smart_banner.allow_reporting
		};

		if (actionInfo.enabled && !this.planInfo.outbound_relay.enabled) {
			this.planInfo.security_awareness.smart_banner.allow_reporting = false;
			this.ns.showErrorMessage(this.dic.ERRORS.allowReportNoOutboundER);
			return;
		}

		this.rs.updateSecurityAwarenessInfo(actionInfo).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	updateSecurityAwarenessExternal = () => {
		const actionInfo = {
			action: this.dic.CONSTANTS.securityAwarenessActions.addExternalNote,
			enabled: this.planInfo.security_awareness.smart_banner.add_external_note
		};
		this.rs.updateSecurityAwarenessInfo(actionInfo).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			this.syncPreviewSeverityTab();
		});
	};

	updateSecurityAwarenessLearnMore = () => {
		const actionInfo = {
			action: this.dic.CONSTANTS.securityAwarenessActions.learnMore,
			enabled: this.planInfo.security_awareness.smart_banner.show_learn_more
		};
		this.rs.updateSecurityAwarenessInfo(actionInfo).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	updateSecurityAwarenessSkipInternal = () => {
		const actionInfo = {
			action: this.dic.CONSTANTS.securityAwarenessActions.skipInternal,
			enabled: this.planInfo.security_awareness.smart_banner.skip_internal
		};
		this.rs.updateSecurityAwarenessInfo(actionInfo).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	updateSecurityAwarenessSkipContact = () => {
		const actionInfo = {
			action: this.dic.CONSTANTS.securityAwarenessActions.skipContact,
			enabled: this.planInfo.security_awareness.smart_banner.skip_contact
		};
		this.rs.updateSecurityAwarenessInfo(actionInfo).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	updateSecurityAwarenessSkipAllowlist = () => {
		const actionInfo = {
			action: this.dic.CONSTANTS.securityAwarenessActions.skipAllowlist,
			enabled: this.planInfo.security_awareness.smart_banner.skip_allowlist
		};
		this.rs.updateSecurityAwarenessInfo(actionInfo).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			this.syncPreviewSeverityTab();
		});
	};

	updateSecurityAwarenessPositiveFeedback = () => {
		const actionInfo = {
			action: this.dic.CONSTANTS.securityAwarenessActions.positiveFeedback,
			enabled: this.planInfo.security_awareness.smart_banner.add_positive_feedback
		};
		this.rs.updateSecurityAwarenessInfo(actionInfo).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			this.syncPreviewSeverityTab();
		});
	};

	previewSeverityTabs = [
		{id: 'danger', label: 'Danger'},
		{id: 'caution', label: 'Caution'},
		{id: 'informational', label: 'Informational'},
		{id: 'trusted', label: 'Trusted'}
	];
	previewSeverityTab = 'danger';

	private readonly previewSeverityRank = {danger: 4, caution: 3, trusted: 2, informational: 1};
	private readonly previewPalette = {
		danger: {bg: '#fff1f0', border: '#f0c4c0', divider: '#f5d0cd', stamp: '#cf222e'},
		caution: {bg: '#fff7ed', border: '#fdba74', divider: '#fed7aa', stamp: '#ea580c'},
		informational: {bg: '#f4f6f8', border: '#d8dde3', divider: '#e6e8eb', stamp: '#57606a'},
		trusted: {bg: '#f0f7ff', border: '#c8ddf5', divider: '#d6e6f7', stamp: '#0969da'}
	};

	private readonly previewActionColors = {
		reportFill: '#cf222e',
		reportStroke: '#cf222e',
		reportText: '#ffffff',
		trustFill: '#ffffff',
		trustStroke: '#0969da',
		trustText: '#0969da'
	};

	private readonly previewPrimaryBySeverity = {
		danger: {title: 'Executive Impersonation', message: 'appears to impersonate an executive in your organization: Jordan Wells, CEO (ceo@example.com)', negative: true, aboutSender: true},
		caution: {title: 'Free Email Sender', message: 'was sent from a free email provider (e.g. Gmail, Yahoo)', negative: true, aboutSender: true},
		informational: {title: 'External Email', message: 'came from outside your organization', negative: true, aboutSender: true},
		trusted: {title: 'Allowlisted Sender', message: 'was marked as safe for your organization', negative: false, aboutSender: true}
	};

	isPreviewTabDisabled(tabId: string) {
		const smartBanner = this.planInfo?.security_awareness?.smart_banner;
		if (tabId === 'trusted') {
			return !smartBanner?.add_positive_feedback;
		}
		return false;
	}

	getPreviewTabDisabledReason(tabId: string) {
		if (!this.isPreviewTabDisabled(tabId)) {
			return null;
		}
		if (tabId === 'trusted') {
			return 'Enable Add positive feedback to preview Trusted banners';
		}
		return null;
	}

	private syncPreviewSeverityTab() {
		if (!this.isPreviewTabDisabled(this.previewSeverityTab)) {
			return;
		}
		const fallback = this.previewSeverityTabs.find(tab => !this.isPreviewTabDisabled(tab.id));
		if (fallback) {
			this.previewSeverityTab = fallback.id;
		}
	}

	private getEffectivePreviewSeverity() {
		if (!this.isPreviewTabDisabled(this.previewSeverityTab)) {
			return this.previewSeverityTab;
		}
		const fallback = this.previewSeverityTabs.find(tab => !this.isPreviewTabDisabled(tab.id));
		return fallback ? fallback.id : 'caution';
	}

	selectPreviewSeverity(tabId: string) {
		if (this.isPreviewTabDisabled(tabId)) {
			return;
		}
		this.previewSeverityTab = tabId;
	}

	private isPreviewTrustFlag(flagObj: {negative?: boolean; color?: string}) {
		return !flagObj.negative && flagObj.color === 'trusted';
	}

	get previewBanner() {
		const smartBanner = this.planInfo?.security_awareness?.smart_banner || {};
		const tabId = this.getEffectivePreviewSeverity();
		let tabPrimary = this.previewPrimaryBySeverity[tabId];
		if (tabId === 'informational') {
			if (smartBanner.add_external_note) {
				tabPrimary = this.previewPrimaryBySeverity.informational;
			} else if (smartBanner.add_positive_feedback) {
				tabPrimary = {
					title: 'Well-Known Domain',
					message: 'came from a widely recognized company or website',
					negative: false,
					aboutSender: true
				};
			} else {
				tabPrimary = {
					title: 'Different Reply Address',
					message: 'if you reply, your message will go to support@other.example.com instead of the sender shown',
					negative: true
				};
			}
		}
		// Match BackEnd skip_allowlist: no banner for allowlisted senders — demo other Trusted signals instead
		if (tabId === 'trusted' && smartBanner.skip_allowlist) {
			tabPrimary = {
				title: 'Authenticated Email',
				message: 'passed authentication for billing@example.com',
				negative: false,
				aboutSender: true
			};
		}
		if (!tabPrimary) {
			return {visible: false};
		}

		const findings = [];
		const primaryColor = tabId;

		findings.push({
			title: tabPrimary.title,
			message: tabPrimary.message,
			color: primaryColor,
			negative: tabPrimary.negative,
			aboutSender: !!tabPrimary.aboutSender
		});

		// Match BackEnd: external note is additive informational context when enabled.
		// Skip on Trusted demos so the allowlist detection phrasing stays primary.
		if (smartBanner.add_external_note && tabId !== 'trusted' && tabId !== 'informational' && tabPrimary.title !== 'External Email') {
			findings.push({
				title: 'External Email',
				message: 'came from outside your organization',
				color: 'informational',
				negative: true,
				aboutSender: true
			});
		}

		if (tabId === 'informational' && smartBanner.add_external_note && smartBanner.add_positive_feedback) {
			findings.push({
				title: 'Well-Known Domain',
				message: 'came from a widely recognized company or website',
				color: 'informational',
				negative: false,
				aboutSender: true
			});
		}

		if (tabId === 'trusted' && smartBanner.add_positive_feedback) {
			if (smartBanner.skip_allowlist) {
				findings.push({
					title: 'Known Contact',
					message: 'came from someone you have sent mail to or received mail from before',
					color: 'trusted',
					negative: false
				});
			} else {
				findings.push({
					title: 'Authenticated Email',
					message: 'passed authentication for billing@example.com',
					color: 'trusted',
					negative: false,
					aboutSender: true
				});
			}
		}

		if (tabId === 'caution') {
			findings.push({
				title: 'Unknown Sender',
				message: 'is from someone your organization has never exchanged mail with before',
				color: 'caution',
				negative: true,
				aboutSender: true
			});
		}

		// Match BackEnd: trust signals only when Add positive feedback is on.
		// Do not inject trust onto caution/informational demos (would steal chrome or drop Free Email Sender).
		// Skip allowlist injection when skip_allowlist is on (BackEnd skips the whole banner for allowlisted senders).
		if (smartBanner.add_positive_feedback && tabId === 'danger' && !smartBanner.skip_allowlist) {
			findings.push({
				title: 'Allowlisted Sender',
				message: 'was marked as safe for your organization',
				color: 'trusted',
				negative: false,
				aboutSender: true
			});
		}

		const hasSafeTrusted = findings.some(f =>
			f.title === 'Allowlisted Sender' || f.title === 'Well-Known Domain' || f.title === 'Trusted Domain');
		const filtered = hasSafeTrusted
			? findings.filter(f => f.title !== 'Free Email Sender')
			: findings;
		if (!filtered.length) {
			return {visible: false};
		}

		filtered.sort((a, b) => {
			const aAllow = a.title === 'Allowlisted Sender';
			const bAllow = b.title === 'Allowlisted Sender';
			if (aAllow !== bAllow) {
				if (aAllow) {
					return (b.color === 'danger' || b.color === 'caution') ? 1 : -1;
				}
				return (a.color === 'danger' || a.color === 'caution') ? -1 : 1;
			}
			const rankDiff = (this.previewSeverityRank[b.color] || 0) - (this.previewSeverityRank[a.color] || 0);
			if (rankDiff) {
				return rankDiff;
			}
			return (b.negative ? 1 : 0) - (a.negative ? 1 : 0);
		});

		const riskFlags = [];
		const trustFlags = [];
		const seenTitles: {[key: string]: boolean} = {};
		for (let i = 0; i < filtered.length; i++) {
			const flagObj = filtered[i];
			const titleKey = (flagObj.title || '').toLowerCase();
			if (titleKey && seenTitles[titleKey]) {
				continue;
			}
			const isTrust = this.isPreviewTrustFlag(flagObj);
			if (isTrust) {
				if (trustFlags.length >= 2) {
					continue;
				}
			} else if (riskFlags.length >= 3) {
				continue;
			}
			if (titleKey) {
				seenTitles[titleKey] = true;
			}
			if (isTrust) {
				trustFlags.push(flagObj);
			} else {
				riskFlags.push(flagObj);
			}
		}

		const mainFlags = riskFlags.length ? riskFlags : trustFlags;
		const titleFinding = mainFlags[0];
		if (!titleFinding) {
			return {visible: false};
		}

		let chromeFinding = titleFinding;
		const hasAllowlistTrust = trustFlags.some(f => f.title === 'Allowlisted Sender');
		const riskIsInfoOnly = riskFlags.length && riskFlags.every(f => f.color === 'informational');
		if (hasAllowlistTrust && riskIsInfoOnly) {
			chromeFinding = trustFlags.find(f => f.title === 'Allowlisted Sender') || chromeFinding;
		}

		const color = chromeFinding.color;
		const palette = this.previewPalette[color] || this.previewPalette.informational;

		// Single-category phrase: only combine findings from the exact same category as the chrome (up to 3 max)
		const allFindings = [...riskFlags, ...trustFlags];
		const matchingCategoryFlags = allFindings.filter(f => (f.color || (f.negative ? 'caution' : 'trusted')) === color);
		const phraseFlags = matchingCategoryFlags.length
			? matchingCategoryFlags.slice(0, 3)
			: [chromeFinding];

		const phrases = phraseFlags.map(f => f.message);
		const subject = phraseFlags.length && phraseFlags.every(f => f.aboutSender) ? 'This sender' : 'This email';
		let phrase = subject + ' ' + phrases[0];
		if (phrases.length === 2) {
			phrase += ' and ' + phrases[1];
		} else if (phrases.length > 2) {
			phrase += ', ' + phrases.slice(1, -1).join(', ') + ', and ' + phrases[phrases.length - 1];
		}
		phrase += '.';

		const severityLabel = color === 'danger' ? 'Danger'
			: color === 'caution' ? 'Caution'
				: color === 'trusted' ? 'Trusted'
					: 'Informational';

		const showBranding = !!smartBanner.show_learn_more;
		const showReporting = !!smartBanner.allow_reporting;
		const showFooter = showReporting;

		return {
			visible: true,
			title: chromeFinding.title,
			severityLabel,
			color,
			phrase,
			showFooter,
			showBranding,
			showReporting,
			...palette,
			...this.previewActionColors
		};
	}

}
